<template>
  <div class="sensors">
    <div class="sensors-wrapper">
      <div
        v-if="computedSensorsLength !== null"
      >
        <p class="sensors__number-of-sensors">
          {{ $t('messages.sharedTexts.showing') }} <strong>{{ computedSensorsLength }} {{ $tc('messages.sharedTexts.sensor', 0) }}</strong>
          <br>
          <br>
          <button
            class="g-btn g-btn--semi-rounded g-btn--red"
            @click.stop="deleteAllSensorsClicked()"
          >
            Delete All <font-awesome-icon :icon="['fas', 'times']" />
          </button>
        </p>
      </div>
      <p
        v-else
        class="g-count-loader"
      >
        <span>{{ $t('messages.sharedTexts.showing') }}</span>
      </p>
      <ul
        ref="sensorsLayout"
        class="sensors__layout"
        :class="{'sensors__layout--show': computedSensorsLength === 0 || sensorsLayoutInited}"
      >
        <slot v-if="computedSensorsLength > 0">
          <li
            v-for="sensor in sensors"
            :key="sensor.data.id"
            class="sensors__layout__item"
          >
            <sensor-component
              :ref="'id:' + sensor.id"
              :store="store"
              :sensor-data="sensor"
              :types="types"
              :page-message="PageMessage"
              @SetPageMessage="SetPageMessage"
              @sensorLoaded="sensorLoaded"
              @openSensorEdit="openSensorEdit"
              @reload-layout="reloadSensorsLayout()"
            />
          </li>
        </slot>
        <li class="sensors__layout__item">
          <div
            class="sensor-decoder-dummy"
            :title="$t('messages.sensors.addNewSensor')"
            @click.stop="addSensor(createBlankSensor())"
          >
            <font-awesome-icon
              v-if="!disableCreate"
              :icon="['fas', 'plus']"
            />
            <font-awesome-icon
              v-else
              :icon="['fas', 'circle-notch']"
              :spin="true"
            />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {SocketHandler, LifeCycle} from '@/assets/javascript/mixins/Mixins'
import {MicroService} from '@/assets/javascript/mixins/Mixins'
import SensorDecoderComponent from '@/components/SensorDecoderComponent'
import Masonry from 'masonry-layout'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

export default {
  name: 'Sensors',
  components: {
    'sensor-component': SensorDecoderComponent,
    'font-awesome-icon': FontAwesomeIcon
  },
  mixins: [SocketHandler, LifeCycle, MicroService],
  props: {
    PageMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    SocketMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    store: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  data() {
    return{
      sensors: [],
      sensorsLoaded: 0,
      sensorsLayoutInited: false,
      sensorsLayout: null,
      types: [],
      disableCreate: false
    }
  },
  computed: {
    computedLanguage() {
      return this.store.getData('settings.internationalization.selectedLocale')
    },
    computedSeqno() {
      return this.sensors.length + 1
    },
    computedCtrlID() {
      return this.store.getData('controller.deviceData.ctrlid')
    },
    computedSensorsLength() {
      return Array.isArray(this.sensors) ? this.sensors.length : 0
    },
    computedControllerModeCheck() {
      return this.controllerMode === 0 || this.controllerMode > 2
    }
  },
  watch: {
    '$route'() {
      this.goToSensor(this.$route.query.id)
    },
    PageMessage({target, command, data}) {
      console.log(target, command)
      if(target === 'sensors') {
        if(command === 'delete') this.deleteSensor(data)
        if(command === 'updateInformation') this.getSDSetup()
      }
      if(target === 'sensors-delete-all') {
        this.deleteAllSensors()
      }
    },
    sensors() {
      if(this.sensorsLayout) {
        this.$nextTick(() => {
          this.sensorsLayout.reloadItems()
          this.sensorsLayout.layout()
        })
      }
    }
  },
  created() {
    this.getSDSetup()
    this.getTranslations()
    this.getSDSetupDrownDown()
  },
  mounted() {
    this.$nextTick(() => {
      this.$emit('SetPageMessage', {
        target: 'FooterButtons',
        data: [{
          label: this.$tc('messages.sharedTexts.station', 0),
          route: '/stations',
          className: 'ButtonLeft'
        }]
      })
    })
  },
  methods: {
    getSDSetupDrownDown() {
      this.sendMicroServiceRequest({
        method: 'GET',
        url: `api/authenticated/function/getsdsetupdropdown?language_code=en-US`
      })
      .then((response) => {
        response.data
        ? this.$set(this, 'types', response.data.getsdsetupdropdown)
        : console.error('no data for getsdsetupdropdown')
      }).catch(console.error)
    },
    getTranslations() {
      this.sendMicroServiceRequest({
        method: 'GET',
        url: `api/authenticated/function/getsdsetuptranslation?language_code=${this.computedLanguage}`
      })
      .then(response => this.setTranslation(response.data.getsdsetuptranslation, 'sdSetup'))
      .catch(console.error)

      this.sendMicroServiceRequest({
        method: 'GET',
        url: `api/authenticated/function/getsdalarmtranslation?language_code=${this.computedLanguage}`
      })
      .then(response => this.setTranslation(response.data.getsdalarmtranslation, 'sdAlarms'))
      .catch(console.error)

      this.sendMicroServiceRequest({
        method: 'GET',
        url: `api/authenticated/function/getsdactiontranslation?language_code=${this.computedLanguage}`
      })
      .then(response => this.setTranslation(response.data.getsdactiontranslation, 'sdActions'))
      .catch(console.error)
    },
    getSDSetup() {
      console.log('getting sensors')
      this.sendMicroServiceRequest({
        method: 'GET',
        url: `api/authenticated/function/getsdsetup?ctrlid=${this.computedCtrlID}`
      })
      .then((response) => {
        console.log(response)
        response.data && response.data.getsdsetup
        ? this.$set(this, 'sensors', response.data.getsdsetup.sort((a, b) => a.data.sdname.localeCompare(b.data.sdname)))
        : console.error('no data for getsdsetup')
      }).catch(console.error)
    },
    setTranslation(data, path) {
      let translation = data.map(tsl => ({[tsl.field]: tsl.lang}))
      translation = Object.assign(...translation)

      this.$emit('SetPageMessage', {
        target: 'updateI18n',
        path: 'sensors.sdSetup',
        data: {
          messages: {
            sensors: {
              [path]: translation
            }
          }
        }
      })
    },
    deleteAllSensorsClicked() {
      this.$emit('SetPageMessage', {
        target: 'ShowModal',
        modalData: {
          component: 'DialogueModal',
          data: {
            title: 'Delete All Sensors?',
            prefix: 'sensors-',
            text: 'This will delete all sensors and their corresponding alarms and actions.',
            options: [
              {label: 'Delete All', value: 'delete-all'}, {label: 'Cancel', value: 'cancel'}
            ]
          }
        }
      })
    },
    deleteAllSensors() {
      this.sendMicroServiceRequest({
        method: 'DELETE',
        url: `api/authenticated/function/deleteallsdsetup?ctrlid=${this.computedCtrlID}`
      }).then((response) => {
        if(response.status !== 200) console.error(response)
        if(response.data.deleteallsdsetup) this.sensors = []
        let Msg = { category: 'server', command: 'synchronize', data: { 'type': 'initiate' } }
        this.SocketMessageSend( Msg )
      }).catch(console.error)
    },
    deleteSensor(data) {
      const sensorIndex = this.sensors.indexOf(this.sensors.find(sensor => sensor.id === data.id))

      if(sensorIndex === -1) return

      this.sendMicroServiceRequest({
        method: 'DELETE',
        url: `api/authenticated/function/deletesdsetup?ctrlid=${data.ctrlid}&id=${data.id}`,
        data
      }).then((response) => {
        if(response.status !== 200) console.error(response)
        if(response.data.deletesdsetup) {
          this.sensors.splice(sensorIndex, 1)
          this.sensorsLoaded -= 1
        }
      }).catch(console.error)
    },
    createBlankSensor() {
      return {
        ctrlid: this.computedCtrlID,
        seqno: this.computedSeqno,
        senstype: null,
        sdname: null,
        sdaddr: null,
        sdtype: null,
        kfact: null,
        offset: null,
        adjust: null,
        globalsum: null,
        syssum: null,
        logtofile: null,
        description: null,
        display: null,
        disable: null,
        units: null,
        consump: null
      }
    },
    addSensor(data) {
      this.disableCreate = true
      this.sendMicroServiceRequest({
        method: 'PUT',
        url: `api/authenticated/function/createsdsetup`,
        data
      })
      .then((response) => {
        if(response.data && response.data.createsdsetup ) {
          const sensorIndex = this.sensors.push(response.data.createsdsetup[0])
          this.$nextTick(() => this.openSensorEdit(this.sensors[sensorIndex - 1]))
          let Msg = { category: 'server', command: 'synchronize', data: { 'type': 'initiate' } }
          this.SocketMessageSend( Msg )
        }
      })
      .catch(console.error)
      .finally(() => this.disableCreate = false)
    },
    openSensorEdit(sensor) {
      let data = {
        data: sensor,
        sensors: this.sensors.length,
        blankSensor: this.createBlankSensor(),
        steps: [{
          component: 'edit-sensor-parameters',
          state: '',
          name: 'Parameters'
        }, {
          component: 'edit-sensor-settings',
          state: '',
          name: 'Settings'
        }, {
          component: 'edit-sensor-alarms',
          state: '',
          name: 'Alarms'
        }
      ]}

      this.$emit('ShowModal', {
        component: 'EditSensors',
        data
      })
    },
    goToSensor(StId) {
      if(this.$route.query.id) {
        let el = this.$refs['id:' + StId][0]
        el = el.$el

        el.parentNode.classList.remove('sensors__layout__item--highlighted')

        setTimeout(() => {
          el.parentNode.classList.add('sensors__layout__item--highlighted')
          this.$el.parentNode.scrollTop += (el.getBoundingClientRect().y +  el.offsetHeight / 2) - (window.innerHeight) / 2
        }, 0)
      }
    },
    SetPageMessage(Message) {
      this.$emit('SetPageMessage', Message)
    },
    reloadSensorsLayout() {
      this.sensorsLayout.layout()
    },
    sensorLoaded(data) {
      this.sensorsLoaded += 1

      if(this.sensorsLoaded === this.computedSensorsLength) {
        if(!this.sensorsLayout) {
          console.debug('all sensors loaded')
          this.$set(this, 'sensorsLayout', new Masonry(this.$refs.sensorsLayout, {
            itemSelector: '.sensors__layout__item',
            columnWidth: '.sensors__layout__item',
            horizontalOrder: true,
            isFitWidth: true
          }))
          this.sensorsLayoutInited = true
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .sensors {
    @keyframes pulse {
      0% {
        opacity: 1;
      }
      50% {
        opacity: 0.35;
      }
      100% {
        opacity: 1;
      }
    }

    &-wrapper {
      max-width: $bp-desktop * 1.5;
      margin: 150px auto 0;

      .no-wheel & {
        margin-top: 20px;
      }
    }

    .sensor-decoder-dummy {
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 225px;
      height: 87px;
      font-size: 35px;
      padding: 11px;
      border: 1px solid $color-grey;
      border-radius: $application-base-border-radius * 2;
      background-color: $color-white;
      color: lighten($color-grey-darker, 10);
      cursor: pointer;
    }

    &__number-of-sensors {
      text-align: right;
      margin-right: 150px;
    }

    &__layout {
      @include clearfix();
      margin: 0 auto 0;
      position: relative;
      opacity: 0;
      transition: opacity 0.4s;

      &--show {
        opacity: 1;
      }

      &__item {
        display: block;
        transform-origin: top center;
        margin: 30px 10px 15px;

        &--highlighted {
          animation: pulse 1s 4;
        }
      }
    }
  }

  @media screen and (min-width: $bp-mobile) {
    .sensors {
      &-wrapper {
        padding: 20px;
      }
    }
  }
</style>
